/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      ipAddress
      contacts {
        items {
          id
          firstName
          lastName
          email
          message
          createdAt
          updatedAt
          userContactsId
        }
        nextToken
      }
      investors {
        items {
          id
          firstName
          lastName
          email
          message
          isAccredited
          createdAt
          updatedAt
          userInvestorsId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      firstName
      lastName
      email
      message
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userContactsId
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        message
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userContactsId
      }
      nextToken
    }
  }
`;
export const getInvestor = /* GraphQL */ `
  query GetInvestor($id: ID!) {
    getInvestor(id: $id) {
      id
      firstName
      lastName
      email
      message
      isAccredited
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userInvestorsId
    }
  }
`;
export const listInvestors = /* GraphQL */ `
  query ListInvestors(
    $filter: ModelInvestorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvestors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        message
        isAccredited
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userInvestorsId
      }
      nextToken
    }
  }
`;
export const usersByIpAddress = /* GraphQL */ `
  query UsersByIpAddress(
    $ipAddress: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UsersByIpAddress(
      ipAddress: $ipAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const contactsByFirstName = /* GraphQL */ `
  query ContactsByFirstName(
    $firstName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ContactsByFirstName(
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userContactsId
      }
      nextToken
    }
  }
`;
export const contactsByLastName = /* GraphQL */ `
  query ContactsByLastName(
    $lastName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ContactsByLastName(
      lastName: $lastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userContactsId
      }
      nextToken
    }
  }
`;
export const contactsByEmail = /* GraphQL */ `
  query ContactsByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ContactsByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userContactsId
      }
      nextToken
    }
  }
`;
export const investorsByFirstName = /* GraphQL */ `
  query InvestorsByFirstName(
    $firstName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvestorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    InvestorsByFirstName(
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        isAccredited
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userInvestorsId
      }
      nextToken
    }
  }
`;
export const investorsByLastName = /* GraphQL */ `
  query InvestorsByLastName(
    $lastName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvestorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    InvestorsByLastName(
      lastName: $lastName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        isAccredited
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userInvestorsId
      }
      nextToken
    }
  }
`;
export const investorsByEmail = /* GraphQL */ `
  query InvestorsByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvestorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    InvestorsByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        message
        isAccredited
        user {
          id
          ipAddress
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        userInvestorsId
      }
      nextToken
    }
  }
`;
